var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame427323565(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4246_116958)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4246_116958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7113 0H3.28867C2.41684 0.00123451 1.58107 0.348114 0.964592 0.964592C0.348115 1.58107 0.00123512 2.41684 6.08946e-07 3.28867V12.7113C-0.00026232 13.1433 0.0846221 13.571 0.2498 13.9702C0.414978 14.3693 0.657209 14.7319 0.962642 15.0374C1.26808 15.3428 1.63072 15.585 2.02984 15.7502C2.42896 15.9154 2.85672 16.0003 3.28867 16H12.7113C13.1433 16.0003 13.571 15.9154 13.9702 15.7502C14.3693 15.585 14.7319 15.3428 15.0374 15.0374C15.3428 14.7319 15.585 14.3693 15.7502 13.9702C15.9154 13.571 16.0003 13.1433 16 12.7113V3.28867C16.0067 1.47533 14.5313 0 12.7113 0ZM4.89067 12.894C4.89067 13.0207 4.792 13.1187 4.666 13.1187H3.11267C3.08306 13.119 3.05369 13.1135 3.02627 13.1023C2.99885 13.0911 2.97394 13.0746 2.95301 13.0537C2.93207 13.0327 2.91554 13.0078 2.90437 12.9804C2.89321 12.953 2.88764 12.9236 2.888 12.894V11.3407C2.888 11.2147 2.98667 11.1167 3.11267 11.1167H4.66667C4.79333 11.1167 4.89133 11.2147 4.89133 11.3413L4.89067 12.894ZM12.9713 11.9033L11.4327 13.4353C11.32 13.5473 11.1513 13.4707 11.1513 13.302V6.38L6.858 10.6733C6.82253 10.7118 6.77896 10.742 6.73042 10.7616C6.68188 10.7812 6.62959 10.7897 6.57733 10.7867H5.446C5.41595 10.7884 5.38588 10.7838 5.35775 10.7731C5.32962 10.7624 5.30408 10.7458 5.28279 10.7245C5.26151 10.7033 5.24497 10.6777 5.23427 10.6496C5.22356 10.6215 5.21892 10.5914 5.22067 10.5613V9.43C5.22067 9.29667 5.256 9.21933 5.33333 9.14867L9.62667 4.85533H2.70533C2.53667 4.85533 2.45933 4.68667 2.572 4.57467L4.10333 3.03533C4.19467 2.944 4.29333 2.88067 4.448 2.88067H12.1C12.6693 2.88067 13.126 3.338 13.126 3.90733V11.5593C13.1193 11.7133 13.0627 11.8047 12.9713 11.9033Z",
    fill: "#FDDB32"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4246_116958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4246_116958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame427323565);
export default __webpack_public_path__ + "static/media/Frame 427323565.b9aa8617e6767f2e9a1057976513cb12.svg";
export { ForwardRef as ReactComponent };